webpackJsonp([1],{

/***/ "1/ZS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D2vx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DN1V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
    name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a873c3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("iEbw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchMenu.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _data = {
    searchStrategy: 'BreadthFirstSearch',
    cols: '10',
    rows: '10',
    strategyOptions: {
        limit: '10'
    },
    isLimit: false,
    showExplored: false,
    stats: {
        cost: 0,
        nodes: 0,
        explored: 0
    },
    isClosed: false
};

/* harmony default export */ var SearchMenu = ({
    name: 'SearchMenu',
    data: function data() {
        return _data;
    },
    created: function created() {
        this.$nextTick(this.initEvents);
    },
    methods: {
        initEvents: function initEvents() {
            this.$eventHub.$on('statistic', this.addStatistic);
        },
        onChangeStrategy: function onChangeStrategy() {
            this.isLimit = this.searchStrategy === 'DepthLimitedSearch';
        },
        doSearch: function doSearch() {
            this.$emit('updateSearch', _data);
        },
        onChangeMap: function onChangeMap() {
            this.$emit('updateMap', _data);
        },
        onToggleExplored: function onToggleExplored() {
            this.$eventHub.$emit('toggleExplored', this.showExplored);
        },
        addStatistic: function addStatistic(solution) {
            this.stats.cost = Math.round(solution.cost);
            this.stats.nodes = solution.nodes;
            this.stats.explored = solution.explored;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49a66592","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchMenu.vue
var SearchMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu",class:{ 'menu--closed': _vm.isClosed },attrs:{"id":"menu"}},[_c('h1',{staticClass:"menu__header"},[_vm._v("Problem Search Explorer\n        "),_c('a',{attrs:{"href":"#","id":"openMenu"},on:{"click":function($event){_vm.isClosed = !_vm.isClosed}}},[(_vm.isClosed)?_c('i',{staticClass:"fa fa-bars",attrs:{"aria-hidden":"true"}}):_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"menu__section section"},[_c('h2',{staticClass:"section__header"},[_vm._v("Search")]),_vm._v(" "),_c('label',{staticClass:"form__label"},[_vm._v("Search Strategy")]),_vm._v(" "),_c('div',{staticClass:"form__row"},[_c('div',{staticClass:"select__icon"},[_c('i',{staticClass:"fas fa-angle-down"}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchStrategy),expression:"searchStrategy"}],staticClass:"form__input menu__select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchStrategy=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.onChangeStrategy()}]}},[_vm._m(0),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),(_vm.isLimit)?_c('div',{staticClass:"form__row"},[_c('label',{staticClass:"form__label form__label--small"},[_vm._v("Depth Limit")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.strategyOptions.limit),expression:"strategyOptions.limit"}],staticClass:"form__input form__input--small",attrs:{"type":"number","placeholder":"Depth Limit","step":"1","min":"1"},domProps:{"value":(_vm.strategyOptions.limit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.strategyOptions, "limit", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form__row"},[_c('button',{staticClass:"form__input form__button",on:{"click":_vm.doSearch}},[_vm._v("Search")])])]),_vm._v(" "),_c('div',{staticClass:"menu__section section"},[_c('h2',{staticClass:"section__header"},[_vm._v("Statistics")]),_vm._v(" "),_c('div',{staticClass:"form__row"},[_c('span',{staticClass:"form__label form__label--small"},[_vm._v("Path Cost")]),_vm._v(" "),_c('div',{staticClass:"form__input form__input--small form__input--inactive"},[_vm._v(_vm._s(_vm.stats.cost))])]),_vm._v(" "),_c('div',{staticClass:"form__row"},[_c('span',{staticClass:"form__label form__label--small"},[_vm._v("Path Nodes")]),_vm._v(" "),_c('div',{staticClass:"form__input form__input--small form__input--inactive"},[_vm._v(_vm._s(_vm.stats.nodes))])]),_vm._v(" "),_c('div',{staticClass:"form__row"},[_c('span',{staticClass:"form__label form__label--small"},[_vm._v("Explored")]),_vm._v(" "),_c('div',{staticClass:"form__input form__input--small form__input--inactive"},[_vm._v(_vm._s(_vm.stats.explored))])])]),_vm._v(" "),_c('div',{staticClass:"menu__section section"},[_c('h2',{staticClass:"section__header"},[_vm._v("Settings")]),_vm._v(" "),_c('div',{staticClass:"form__row"},[_c('span',{staticClass:"form__label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showExplored),expression:"showExplored"}],staticClass:"checkbox",attrs:{"id":"showExplored","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showExplored)?_vm._i(_vm.showExplored,null)>-1:(_vm.showExplored)},on:{"change":[function($event){var $$a=_vm.showExplored,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showExplored=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showExplored=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showExplored=$$c}},function($event){_vm.onToggleExplored()}]}}),_vm._v(" "),_c('label',{staticClass:"checkbox-label",attrs:{"for":"showExplored"}},[_vm._v("Show Explored")])])])]),_vm._v(" "),_c('div',{staticClass:"menu__section section"},[_c('h2',{staticClass:"section__header"},[_vm._v("Map")]),_vm._v(" "),_c('div',{staticClass:"form__row"},[_c('label',{staticClass:"form__label form__label--small"},[_vm._v("Columns")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cols),expression:"cols"}],staticClass:"form__input form__input--small",attrs:{"type":"number","placeholder":"Columns (e.g. 10)","step":"1","min":"1","max":"50"},domProps:{"value":(_vm.cols)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cols=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form__row"},[_c('label',{staticClass:"form__label form__label--small"},[_vm._v("Rows")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rows),expression:"rows"}],staticClass:"form__input form__input--small",attrs:{"type":"number","placeholder":"Rows (e.g. 10)","step":"1","min":"1","max":"50"},domProps:{"value":(_vm.rows)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rows=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form__row"},[_c('button',{staticClass:"form__input form__button",on:{"click":_vm.onChangeMap}},[_vm._v("Build Map")])])]),_vm._v(" "),_vm._m(2)])}
var SearchMenu_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('optgroup',{attrs:{"label":"Uninformed Search"}},[_c('option',{attrs:{"value":"BreadthFirstSearch"}},[_vm._v("Breadth First Search")]),_vm._v(" "),_c('option',{attrs:{"value":"UniformCostSearch"}},[_vm._v("Uniform Cost Search")]),_vm._v(" "),_c('option',{attrs:{"value":"DepthFirstSearch"}},[_vm._v("Depth First Search")]),_vm._v(" "),_c('option',{attrs:{"value":"DepthLimitedSearch"}},[_vm._v("Depth Limited Search")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('optgroup',{attrs:{"label":"Informed Search"}},[_c('option',{attrs:{"value":"GreedyBestFirstSearch"}},[_vm._v("Greedy Best First Search")]),_vm._v(" "),_c('option',{attrs:{"value":"AStarSearch"}},[_vm._v("A* Search")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu__section section"},[_c('a',{staticClass:"link",attrs:{"href":"https://github.com/marcbreitung/problem-search-explorer","target":"_blank"}},[_c('i',{staticClass:"fab fa-github"}),_vm._v(" Problem Search Explorer\n        ")])])}]
var SearchMenu_esExports = { render: SearchMenu_render, staticRenderFns: SearchMenu_staticRenderFns }
/* harmony default export */ var components_SearchMenu = (SearchMenu_esExports);
// CONCATENATED MODULE: ./src/components/SearchMenu.vue
function SearchMenu_injectStyle (ssrContext) {
  __webpack_require__("D2vx")
}
var SearchMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SearchMenu___vue_template_functional__ = false
/* styles */
var SearchMenu___vue_styles__ = SearchMenu_injectStyle
/* scopeId */
var SearchMenu___vue_scopeId__ = "data-v-49a66592"
/* moduleIdentifier (server only) */
var SearchMenu___vue_module_identifier__ = null
var SearchMenu_Component = SearchMenu_normalizeComponent(
  SearchMenu,
  components_SearchMenu,
  SearchMenu___vue_template_functional__,
  SearchMenu___vue_styles__,
  SearchMenu___vue_scopeId__,
  SearchMenu___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchMenu = (SearchMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchMap.vue
//
//
//
//
//
//

var ProblemGraphVisualisation = __webpack_require__("H2yu");
var SearchMap__data = {
    map: null,
    canvas: null,
    visualisation: null,
    showExplored: false,
    explored: null
};

/* harmony default export */ var SearchMap = ({
    name: 'SearchMap',
    data: function data() {
        return SearchMap__data;
    },
    created: function created() {
        this.$nextTick(this.init);
        this.$nextTick(this.initEvents);
    },
    methods: {
        init: function init() {
            var _this = this;

            this.map = document.getElementById('map');
            this.canvas = document.getElementById('canvas');
            this.canvas.addEventListener('click', function (e) {
                _this.$eventHub.$emit('click-canvas', { 'x': e.offsetX, 'y': e.offsetY });
            }, false);
            this.visualisation = new ProblemGraphVisualisation.Canvas({
                'element': this.canvas,
                'height': this.map.offsetHeight,
                'width': this.map.offsetWidth,
                'background': '#D9CFC7'
            });
            this.visualisation.rendererFactory.registerRenderer('node', ProblemGraphVisualisation.NodesRenderer);
            this.visualisation.rendererFactory.registerRenderer('text', ProblemGraphVisualisation.TextRenderer);
            this.visualisation.rendererFactory.registerRenderer('solution', ProblemGraphVisualisation.SolutionRenderer);
            this.visualisation.rendererFactory.registerRenderer('highlight-node', ProblemGraphVisualisation.HighlightNodeRenderer);
        },
        initEvents: function initEvents() {
            this.$eventHub.$on('nodes', this.addNodes);
            this.$eventHub.$on('start', this.addStart);
            this.$eventHub.$on('goal', this.addGoal);
            this.$eventHub.$on('solution', this.addSolution);
            this.$eventHub.$on('explored', this.addExplored);
            this.$eventHub.$on('toggleExplored', this.onToggleExplored);
        },
        onToggleExplored: function onToggleExplored(value) {
            this.showExplored = value;
            this.visualisation.removeLayerByName('exploredLayer');
            this.visualisation.update();
            if (this.showExplored && this.explored) {
                this.addExplored(this.explored);
            }
        },
        addNodes: function addNodes(nodes) {
            this.explored = null;
            this.visualisation.resize({ 'height': this.map.offsetHeight, 'width': this.map.offsetWidth });
            this.visualisation.removeLayerByName('baseLayer');
            this.visualisation.removeLayerByName('solutionLayer');
            this.visualisation.removeLayerByName('exploredLayer');
            this.visualisation.removeLayerByName('startLayer');
            this.visualisation.removeLayerByName('goalLayer');
            var baseLayer = new ProblemGraphVisualisation.Layer('baseLayer', {
                'type': 'node',
                'sorting': 0,
                'nodes': nodes,
                'nodeColor': '#656A73',
                'lineColor': '#656A73',
                'textColor': '#656A73',
                'lineSize': 1,
                'nodeSize': 5
            });
            this.visualisation.addLayer(baseLayer);
            this.visualisation.update();
        },
        addExplored: function addExplored(nodes) {
            this.explored = nodes;
            if (this.showExplored) {
                var exploredLayer = new ProblemGraphVisualisation.Layer('exploredLayer', {
                    'type': 'highlight-node',
                    'sorting': 1,
                    'nodes': nodes,
                    'nodeColor': '#e7e7e7',
                    'nodeSize': 3
                });
                this.visualisation.addLayer(exploredLayer);
                this.visualisation.update();
            } else {
                this.visualisation.removeLayerByName('exploredLayer');
                this.visualisation.update();
            }
        },
        addStart: function addStart(node) {
            this.resetSolution();
            node.label = 'A';
            var startLayer = new ProblemGraphVisualisation.Layer('startLayer', {
                'type': 'text',
                'sorting': 4,
                'nodes': [node],
                'nodeColor': '#507b0f',
                'lineColor': '#000000',
                'textColor': '#e7e7e7',
                'nodeSize': 12,
                'textSize': 12
            });
            this.visualisation.addLayer(startLayer);
            this.visualisation.update();
        },
        addGoal: function addGoal(node) {
            node.label = 'B';
            var goalLayer = new ProblemGraphVisualisation.Layer('goalLayer', {
                'type': 'text',
                'sorting': 5,
                'nodes': [node],
                'nodeColor': '#e34f00',
                'lineColor': '#000000',
                'textColor': '#e7e7e7',
                'nodeSize': 12,
                'textSize': 12
            });
            this.visualisation.addLayer(goalLayer);
            this.visualisation.update();
        },
        addSolution: function addSolution(nodes) {
            var solutionLayer = new ProblemGraphVisualisation.Layer('solutionLayer', {
                'type': 'solution',
                'sorting': 2,
                'nodes': nodes,
                'nodeColor': '#e34f00',
                'lineColor': '#e34f00',
                'textColor': '#e34f00',
                'lineSize': 3
            });
            this.visualisation.addLayer(solutionLayer);
            this.visualisation.update();
        },
        resetSolution: function resetSolution() {
            this.explored = null;
            this.visualisation.removeLayerByName('solutionLayer');
            this.visualisation.removeLayerByName('exploredLayer');
            this.visualisation.removeLayerByName('startLayer');
            this.visualisation.removeLayerByName('goalLayer');
            this.visualisation.update();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fc8980c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchMap.vue
var SearchMap_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var SearchMap_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map",attrs:{"id":"map"}},[_c('canvas',{attrs:{"id":"canvas"}})])}]
var SearchMap_esExports = { render: SearchMap_render, staticRenderFns: SearchMap_staticRenderFns }
/* harmony default export */ var components_SearchMap = (SearchMap_esExports);
// CONCATENATED MODULE: ./src/components/SearchMap.vue
function SearchMap_injectStyle (ssrContext) {
  __webpack_require__("DN1V")
}
var SearchMap_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SearchMap___vue_template_functional__ = false
/* styles */
var SearchMap___vue_styles__ = SearchMap_injectStyle
/* scopeId */
var SearchMap___vue_scopeId__ = "data-v-1fc8980c"
/* moduleIdentifier (server only) */
var SearchMap___vue_module_identifier__ = null
var SearchMap_Component = SearchMap_normalizeComponent(
  SearchMap,
  components_SearchMap,
  SearchMap___vue_template_functional__,
  SearchMap___vue_styles__,
  SearchMap___vue_scopeId__,
  SearchMap___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchMap = (SearchMap_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Explorer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var ProblemMapGenerator = __webpack_require__("Ua05");
var ProblemSearch = __webpack_require__("tXa0");
var Explorer__data = {
    start: null,
    goal: null,
    map: null,
    mapElement: null,
    searchStrategyFabric: null,
    searchStrategy: null,
    mapHasNodes: false
};

/* harmony default export */ var Explorer = ({
    components: { SearchMap: src_components_SearchMap, SearchMenu: src_components_SearchMenu },
    name: 'Explorer',
    data: function data() {
        return Explorer__data;
    },
    created: function created() {
        this.$nextTick(this.init);
    },
    methods: {
        init: function init() {
            this.mapElement = document.getElementById('map');
            this.searchStrategyFactory = new ProblemSearch.StrategyFactory();
            this.searchStrategyFactory.registerStrategy('BreadthFirstSearch', ProblemSearch.BreadthFirstSearch);
            this.searchStrategyFactory.registerStrategy('UniformCostSearch', ProblemSearch.UniformCostSearch);
            this.searchStrategyFactory.registerStrategy('DepthFirstSearch', ProblemSearch.DepthFirstSearch);
            this.searchStrategyFactory.registerStrategy('DepthLimitedSearch', ProblemSearch.DepthLimitedSearch);
            this.searchStrategyFactory.registerStrategy('GreedyBestFirstSearch', ProblemSearch.GreedyBestFirstSearch);
            this.searchStrategyFactory.registerStrategy('AStarSearch', ProblemSearch.AStarSearch);
            this.$eventHub.$on('click-canvas', this.findNode);
            this.map = new ProblemMapGenerator.Map({});
            this.map.injectRandom(ProblemMapGenerator.Random);
        },
        updateSearch: function updateSearch(value) {
            var graph = void 0,
                problem = void 0,
                result = void 0;
            if (this.mapHasNodes === false) {
                this.$modal.show('map');
                return false;
            }
            if (this.start === null || this.goal === null) {
                this.$modal.show('select');
                return false;
            }
            this.searchStrategy = this.searchStrategyFactory.getStrategy(value.searchStrategy, value.strategyOptions);
            graph = new ProblemSearch.Graph();
            graph.addNodes(this.map.getNodes());
            problem = new ProblemSearch.Problem(graph, new ProblemSearch.State(this.start), new ProblemSearch.State(this.goal));
            try {
                result = this.searchStrategy.search(problem);
                this.$eventHub.$emit('solution', result.solutionGraph());
                this.$eventHub.$emit('statistic', {
                    'cost': result.solution().pop().pathCost,
                    'nodes': result.solution().length,
                    'explored': this.searchStrategy.explored.length
                });
                this.$eventHub.$emit('explored', this.searchStrategy.explored.map(function (node) {
                    return node.state.node;
                }));
            } catch (e) {
                if (e.name === 'NoSolutionException') {
                    this.$modal.show('solution');
                }
                if (e.name === 'LimitException') {
                    this.$modal.show('limit');
                }
            }
        },
        updateMap: function updateMap(value) {
            this.map.setSettings({
                'cols': parseInt(value.cols, 10),
                'rows': parseInt(value.rows, 10),
                'width': this.mapElement.offsetWidth,
                'height': this.mapElement.offsetHeight
            });
            this.start = null;
            this.goal = null;
            this.mapHasNodes = true;
            this.$eventHub.$emit('nodes', this.map.getNodes());
            this.$eventHub.$emit('statistic', {
                'cost': 0,
                'nodes': 0,
                'explored': 0
            });
        },
        addNode: function addNode(node) {
            if (this.start === null && this.goal === null) {
                this.start = node;
                this.$eventHub.$emit('start', this.start);
                return false;
            }
            if (this.start !== null && this.goal === null) {
                this.goal = node;
                this.$eventHub.$emit('goal', this.goal);
                return true;
            }
            if (this.start !== null && this.goal !== null) {
                this.goal = null;
                this.start = node;
                this.$eventHub.$emit('start', this.start);
                return true;
            }
        },
        findNode: function findNode(position) {
            var node = this.map.findNodeByPosition(position, 10);
            if (node) {
                this.addNode(node);
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-186dbdbe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Explorer.vue
var Explorer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"explorer",attrs:{"id":"explorer"}},[_c('search-menu',{on:{"updateSearch":_vm.updateSearch,"updateMap":_vm.updateMap}}),_vm._v(" "),_c('search-map'),_vm._v(" "),_c('modal',{attrs:{"name":"select","height":"auto"}},[_c('div',{staticClass:"modal"},[_vm._v("\n            Please select a start and a goal node.\n        ")])]),_vm._v(" "),_c('modal',{attrs:{"name":"solution","height":"auto"}},[_c('div',{staticClass:"modal"},[_vm._v("\n            No solution found.\n        ")])]),_vm._v(" "),_c('modal',{attrs:{"name":"map","height":"auto"}},[_c('div',{staticClass:"modal"},[_vm._v("\n            You must generate a map. Please click the \"Build Map\" button.\n        ")])]),_vm._v(" "),_c('modal',{attrs:{"name":"limit","height":"auto"}},[_c('div',{staticClass:"modal"},[_vm._v("\n            Maximum depth limit reached.\n        ")])])],1)}
var Explorer_staticRenderFns = []
var Explorer_esExports = { render: Explorer_render, staticRenderFns: Explorer_staticRenderFns }
/* harmony default export */ var components_Explorer = (Explorer_esExports);
// CONCATENATED MODULE: ./src/components/Explorer.vue
function Explorer_injectStyle (ssrContext) {
  __webpack_require__("1/ZS")
}
var Explorer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Explorer___vue_template_functional__ = false
/* styles */
var Explorer___vue_styles__ = Explorer_injectStyle
/* scopeId */
var Explorer___vue_scopeId__ = "data-v-186dbdbe"
/* moduleIdentifier (server only) */
var Explorer___vue_module_identifier__ = null
var Explorer_Component = Explorer_normalizeComponent(
  Explorer,
  components_Explorer,
  Explorer___vue_template_functional__,
  Explorer___vue_styles__,
  Explorer___vue_scopeId__,
  Explorer___vue_module_identifier__
)

/* harmony default export */ var src_components_Explorer = (Explorer_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js




vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

vue_esm["a" /* default */].prototype.$eventHub = new vue_esm["a" /* default */]();

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
    routes: [{
        path: '/',
        name: 'Explorer',
        component: src_components_Explorer
    }]
}));
// EXTERNAL MODULE: ./node_modules/vue-js-modal/dist/index.js
var dist = __webpack_require__("rifk");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





vue_esm["a" /* default */].use(dist_default.a, { dialog: true });
vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
    el: '#app',
    router: router,
    template: '<App/>',
    components: { App: src_App }
});

/***/ }),

/***/ "iEbw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a73efbaf6af823a1ce03.js